import React, { useEffect } from 'react'
import {
    FormControl,
    InputLabel,
    ListSubheader,
    makeStyles,
    MenuItem,
    Select,
} from '@material-ui/core'
import { editableMergeField } from '../constants/editableMergeField.constants'

type MergeField = {
    id: number
    type: number | null
    value: string
}

type SelectedMergeField = {
    id: number
    type: number | null
}

type Props = {
    selectedMergeField: SelectedMergeField
    onChange: (field: SelectedMergeField) => void
    groupedFields: Record<string, MergeField[]>
    allFields: MergeField[]
}

const useStyles = makeStyles({
    formControl: { width: '200px', marginRight: '30px', marginBottom: '20px' },
})

const MergeFieldSelect = ({
    selectedMergeField,
    onChange,
    groupedFields,
    allFields,
}: Props) => {
    const classes = useStyles()

    useEffect(() => {
        if (selectedMergeField.type === editableMergeField.EventType) {
            onChange({
                id: selectedMergeField.id,
                type: selectedMergeField.type,
            })
        }
    }, [selectedMergeField])

    return (
        <FormControl className={classes.formControl}>
            <InputLabel id='merge-field-dropdown'>Merge Field</InputLabel>
            <Select
                labelId='merge-field-dropdown'
                aria-label='Select merge field'
                value={selectedMergeField.id}
                onChange={(e: React.ChangeEvent<{ value: unknown }>) => {
                    const id = e.target.value as number
                    const item = allFields.find(f => f.id === id) || {
                        id: 0,
                        type: null,
                    }
                    onChange({ id: item.id, type: item.type })
                }}
                renderValue={(id: unknown) => {
                    const match = allFields.find(f => f.id === id)
                    return match?.value || 'None'
                }}
            >
                <MenuItem value={0}>None</MenuItem>
                {Object.entries(groupedFields).flatMap(([label, items]) => [
                    <ListSubheader key={`header-${label}`}>
                        {label}
                    </ListSubheader>,
                    ...items.map(item => (
                        <MenuItem key={item.id} value={item.id}>
                            {item.value}
                        </MenuItem>
                    )),
                ])}
            </Select>
        </FormControl>
    )
}

export default MergeFieldSelect
